import { render, staticRenderFns } from "./AddItemGeneral.vue?vue&type=template&id=51f3c694&scoped=true&"
import script from "./AddItemGeneral.vue?vue&type=script&lang=js&"
export * from "./AddItemGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AddItemGeneral.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddItemGeneral.vue?vue&type=style&index=1&id=51f3c694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f3c694",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
